export default "__VITE_PUBLIC_ASSET__ac8495a1__"